import { SubmittalStatusBadge } from './SubmittalStatusBadge';
import type { SubmittalRevision } from '@/hooks/useSubmittals';

interface SubmittalRevisionHistoryProps {
  revisions: SubmittalRevision[];
}

export function SubmittalRevisionHistory({ revisions }: SubmittalRevisionHistoryProps) {
  if (revisions.length === 0) return null;

  return (
    <div className="space-y-2">
      <span className="text-xs font-medium text-muted-foreground">
        Revision History
      </span>
      <div className="space-y-2">
        {revisions.map((rev, i) => (
          <div
            key={rev.id}
            className="flex items-start gap-3 text-sm"
          >
            <div className="flex flex-col items-center">
              <div className="w-6 h-6 rounded-full bg-primary/10 text-primary flex items-center justify-center text-xs font-medium">
                {rev.revision}
              </div>
              {i < revisions.length - 1 && (
                <div className="w-px h-4 bg-border mt-1" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <SubmittalStatusBadge status={rev.status} className="text-[10px] px-1.5 py-0" />
                {rev.date_submitted && (
                  <span className="text-xs text-muted-foreground">
                    {new Date(rev.date_submitted).toLocaleDateString()}
                  </span>
                )}
                {rev.date_returned && (
                  <span className="text-xs text-muted-foreground">
                    — returned {new Date(rev.date_returned).toLocaleDateString()}
                  </span>
                )}
              </div>
              {rev.reviewer_comments && (
                <p className="text-xs text-muted-foreground mt-1">{rev.reviewer_comments}</p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
